angular.module('app').directive('inputfileOnchange', [function(){
    'use strict';
    return {
        scope: {
            callBack: '&inputfileOnchange'
        },
        link: function(scope, element){
            element.on('change', function(event){
                scope.callBack({myEventArg: event});
            });

            scope.$on('$destroy', function () {
                element.off('change');
            });
        }
    };
}]);